import { useState } from "react";
import validateForm from "../../../utils/Validation";
import Axios from "../../../utils/Axios";
import { ADD_TASK } from "../../../config/API_Collection";
import AuthHandler from "../../../utils/AuthHandler";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";

const AddTask = ({
  budgets,
  selectedBudget,
  showToast,
  CloseModalAdd,
  refreshProjectData,
  setToast,
}) => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const budgetIsRequired = budgets.length > 0;

  const requireDatesAndOrder = (payload, errors) => {
    if (payload.task_start_date && payload.task_end_date) {
      const s = new Date(payload.task_start_date);
      const e = new Date(payload.task_end_date);
      if (!isNaN(s) && !isNaN(e) && s > e) {
        errors.task_end_date = "End date must be after start date.";
      }
    }
  };
  const clearTaskError = (name) => {
    if (formErrors?.[name]) {
      const next = { ...formErrors };
      delete next[name];
      setFormErrors(next);
    }
  };

  const handleAddTask = async (e) => {
    e.preventDefault();
    const form = e.target;

    const payload = {
      budget_id: parseInt(form.budget.value),
      task_name: (form.task_name.value || "").trim(),
      task_type: parseInt(form.task_type.value),
      task_start_date: startDate ? startDate.toLocaleDateString("en-CA") : "",
      task_end_date: endDate ? endDate.toLocaleDateString("en-CA") : "",
    };

    const requiredFields = [
      ...(budgetIsRequired ? ["budget_id"] : []),
      "task_name",
      "task_type",
    ];

    const errors = validateForm(payload, requiredFields) || {};
    Object.keys(errors).forEach((k) => (errors[k] = "This field is required."));

    if (budgetIsRequired) {
      if (payload.budget_id && Number.isNaN(payload.budget_id)) {
        errors.budget_id = "Select a valid budget.";
      }
    } else {
      delete errors.budget_id;
    }

    if (payload.task_type && ![1, 2].includes(payload.task_type)) {
      errors.task_type = "Select a valid task type.";
    }

    requireDatesAndOrder(payload, errors);

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      const response = await Axios.post(ADD_TASK, payload);
      if (response.status === 200) {
        showToast("Task Added Successfully!", "success");
        CloseModalAdd();
        refreshProjectData();
      }
    } catch (error) {
      AuthHandler(error.response?.status, setToast, navigate);
    }
  };

  return (
    <div className="add-budget-container">
      <form className="budget-form" onSubmit={handleAddTask}>
        <div className="form-row">
          <div
            className={`form-group flex-item ${
              formErrors.task_name ? "has-error" : ""
            }`}
          >
            <label>Task Name *</label>
            <input
              type="text"
              name="task_name"
              onChange={() => clearTaskError("task_name")}
            />
            {formErrors.task_name && (
              <div className="error-text">{formErrors.task_name}</div>
            )}
          </div>
        </div>

        <div className="form-row">
          <div
            className={`form-group flex-item ${
              formErrors.budget_id ? "has-error" : ""
            }`}
          >
            <label>Budget {budgetIsRequired && <span>*</span>}</label>
            <select
              name="budget"
              defaultValue={budgetIsRequired ? selectedBudget : ""}
              onChange={() => clearTaskError("budget_id")}
              disabled={!budgetIsRequired}
            >
              {budgetIsRequired ? (
                <>
                  <option value="">Select budget</option>
                  {budgets.map((b) => (
                    <option key={b.bid} value={b.bid}>
                      {b.budget_name}
                    </option>
                  ))}
                </>
              ) : (
                <option value="">No budgets available</option>
              )}
            </select>
            {budgetIsRequired && formErrors.budget_id && (
              <div className="error-text">{formErrors.budget_id}</div>
            )}
          </div>

          <div
            className={`form-group flex-item ${
              formErrors.task_type ? "has-error" : ""
            }`}
          >
            <label>Payment Type *</label>
            <select
              name="task_type"
              onChange={() => clearTaskError("task_type")}
            >
              <option value="">Select type</option>
              <option value="1">Hourly Rate</option>
              <option value="2">Fixed Rate</option>
            </select>
            {formErrors.task_type && (
              <div className="error-text">{formErrors.task_type}</div>
            )}
          </div>
        </div>

        <div className="form-row">
          <div
            className={`form-group flex-item ${
              formErrors.task_start_date ? "has-error" : ""
            }`}
          >
            <label>Start Date</label>
            <DatePicker
              selected={startDate}
              onChange={(d) => {
                setStartDate(d);
                clearTaskError("task_start_date");
              }}
              dateFormat="yyyy-MM-dd"
            />
            {formErrors.task_start_date && (
              <div className="error-text">{formErrors.task_start_date}</div>
            )}
          </div>

          <div
            className={`form-group flex-item ${
              formErrors.task_end_date ? "has-error" : ""
            }`}
          >
            <label>End Date</label>
            <DatePicker
              selected={endDate}
              onChange={(d) => {
                setEndDate(d);
                clearTaskError("task_end_date");
              }}
              dateFormat="yyyy-MM-dd"
            />
            {formErrors.task_end_date && (
              <div className="error-text">{formErrors.task_end_date}</div>
            )}
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Create Task
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={CloseModalAdd}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddTask;
